import React from 'react'
import './aboutUs.css'
import Menubar from '../home/menubar/Menubar'
import Address from '../home/footer/Address'
import LinearProgressBar from './LinearProgressBar.jsx'
import ScrollToTopProgress from '../home/header/ScrollToTopProgress.jsx'
import {aboutImg, about} from '../home/data.js'
import Header from '../home/header/Header.jsx'

function AboutUs() {
  const {about_url}=aboutImg
  const {about_img_url} = about
  return (
    <div>
        <Header/>
        <Menubar/>
        <div>
      <div className='about-img'>
            <img src={about_img_url } style={{width: '100%'}} alt="About-US" />
          </div>
	<section className='about'>
		<div className="">
			<h1 style={{borderBottomStyle: 'groove'}}>About Us</h1>
		</div>
	</section>

            <div className="container">
		 <div className="row">
                <div className="container mt-4 col-md-5 col-sm-10 contrainer-sleft">
					<div className="">
						<p><b>Adarsh Computer Training Institute</b>is the ideal place to build your skills — from fundamental computer basics to advanced-level expertise. Since our establishment in 2015, we’ve successfully trained over <b>800 students</b> with practical, career-oriented learning.</p>
            <p>We offer a wide range of courses including <b>Computer Basics, MS Office, DTP, Video Editing, HTML, C Language,</b> and <b>Tally</b>, all backed by an <b>authorized government certificate</b>.</p>
            <p>Our training is structured with <b>daily assignments, batch-wise classes</b>, and <b>ample systems</b> to ensure every student gets hands-on experience. What sets us apart is our <b>direct interaction with students</b> throughout the learning process, creating a supportive and engaging environment.</p>
            <p>Our lead trainer brings expertise from top institutes in <b>Chennai</b> and <b>Warangal</b>, with high-level teaching experience across all offered courses. Whether you're just starting or aiming to upgrade your skills, Adarsh Computer Training Institute is the place to grow.</p>
          </div>
          </div>


      <div className="container mt-4 col-md-6 col-sm-10 contrainer-sright">
        <div>
          <img className='img-abt' src={about_url} alt='contact-Us'></img>
        </div>
      </div>

      </div>
      </div>

             <div className="container strengths">
                <div className="row">
                  <div className="container mt-4 col-md-5 col-sm-10">
                    <div>
                    <h5>Training Infrastructure</h5>
                    <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>
                    <div>
                      <h5>Teaching skill</h5>
                      <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>
                    <div>
                      <h5>Certification</h5>
                      <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>
                  </div>

                    <div className="container mt-4 col-md-5 col-sm-10">
                      <div>
                      <h5>Programming Knowledge</h5>
                      <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>
                    <div>
                      <h5>Professional Teacher</h5>
                      <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>
                    <div>
                      <h5>Assignments</h5>
                      <LinearProgressBar percentage={100} height={25} marginTop={10} marginBottom={30}/>
                    </div>

                  </div>
              </div>
            </div>

            
        </div>
        <Address/>
        <ScrollToTopProgress/>
    </div>
  )
}

export default AboutUs